import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05a1f1a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=05a1f1a2&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=05a1f1a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1f1a2",
  null
  
)

export default component.exports